import { Modal, Table, Input, Tooltip, Tag, message, Button } from 'antd'
import React, { useRef, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { CloseOutlined, DownloadOutlined } from '@ant-design/icons'
import { http } from '@services/http'
import { useQuery } from '@tanstack/react-query'
import moment from 'moment'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'
import ViewIcon from '@assets/icons/viewSvg'
import ClientsDebtSalesModal from './SalesByDateAndManager'

const SalesByDateAndManager = ({ visible, data, onClose }) => {
	const today = moment().format('YYYY-MM-DD')

	const { t } = useTranslation()

	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState(today)
	const [cardCode, setCardCode] = useState('')
	const [slpCode, setSlpCode] = useState('')
	const [loading, setLoading] = useState(false)
	const [pageSize, setPageSize] = useState(1000)
	const [currentPage, setCurrentPage] = useState(0)
	const [date, setDate] = useState('')

	const [viewModalOpen, setViewModalOpen] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)

	const handleStartDate = (e) => {
		setStartDate(e.target.value)
	}
	const handleEndDate = (e) => {
		setEndDate(e.target.value)
	}

	useEffect(() => {
		setDate(data?.docDate)
	}, [data, visible])

	const fetchSalesByDate = async ({ queryKey }) => {
		const [_, date, skip, pageSize] = queryKey
		try {
			const { data } = await http.get(
				`api/salesdata/sales-by-date?date=${date}&skip=${skip}&pageSize=${pageSize}`,
			)
			return data
		} catch (error) {
			console.error('Error fetching data:', error)
		}
	}

	const { data: slpDebtorsData = [], isLoading } = useQuery({
		queryKey: ['salesByDate', date, currentPage, pageSize],
		queryFn: fetchSalesByDate,
		enabled: !!date,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
		refetchOnMount: true,
		refetchOnReconnect: true,
	})

	const columnsDebtors = [
		{
			title: t('slpName'),
			dataIndex: 'salesPersonName',
			key: 'salesPersonName',
		},

		{
			title: t('salesQty'),
			dataIndex: 'numberOfSales',
			key: 'numberOfSales',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return `${formattedText} `
			},
		},
		{
			title: t('docDate'),
			dataIndex: 'docDate',
			key: 'docDate',
			render: (text) => {
				return `${moment(text).format('DD.MM.YYYY')}`
			},
		},

		{
			title: t('totalInvoiceAmount'),
			dataIndex: 'totalInvoiceAmount',
			key: 'totalInvoiceAmount',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return `${formattedText} `
			},
		},
		{
			title: t('totalPaidAmount'),
			dataIndex: 'totalPaidAmount',
			key: 'totalPaidAmount',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return `${formattedText} `
			},
		},
		{
			title: t('debtUzs'),
			dataIndex: 'totalOutstandingAmount',
			key: 'totalOutstandingAmount',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return `${formattedText} `
			},
		},

		{
			title: '',
			dataIndex: 'action',
			key: 'action',
			text: 'center',
			render: (text, record) => (
				<div className="flex flex-col md:flex-row gap-2 items-center justify-start">
					<button
						onClick={() => handleViewClick(record)}
						className="bg-[#2198c7] text-white w-[35px] h-[30px] rounded-lg flex justify-center items-center"
					>
						<ViewIcon />
					</button>
				</div>
			),
		},

		// 	],
		// },
	]

	const handleViewClick = (record) => {
		setSelectedRowData(record)
		setViewModalOpen(true)
	}

	const onCloseModal = () => {
		setStartDate('')
		setEndDate(today)
		onClose()
		setCardCode('')
		setSlpCode('')
	}

	return (
		<Modal
			title={null}
			visible={visible}
			onCancel={onCloseModal}
			footer={null}
			closeIcon={<CloseOutlined />}
			width="75%"
			style={{ height: '85%' }}
			bodyStyle={{ height: 'calc(100% - 55px)', overflowY: 'auto' }}
		>
			<div className="w-full px-5">
				<div className="mt-5 flex flex-col items-end justify-between sm:flex-row">
					<span className="font-bold text-[16px]">
						{t('salesTo')} : {moment(date).format('DD.MM.YYYY')}
					</span>
				</div>

				<div className="mt-10 flex w-full flex-col gap-5">
					<Table
						columns={columnsDebtors}
						dataSource={slpDebtorsData}
						pagination={false}
						loading={isLoading}
						className="border-1 border-black"
					/>
				</div>
			</div>
			<ClientsDebtSalesModal
				visible={viewModalOpen}
				onClose={() => setViewModalOpen(false)}
				data={selectedRowData}
				tableData={data}
			/>
		</Modal>
	)
}

export default SalesByDateAndManager
